// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import "babel-polyfill"
import App from './App'
import router from './router/index'
import Element from 'element-ui'
import './CSS/newTheme.scss'
import store from './store'
import VueDND from 'awe-dnd'
import htmlToPdf from './util/htmlToPdf'
import VideoPlayer from 'vue-video-player'
import 'videojs-contrib-hls'

// 引入自定义指令
import './directives/directive.js';
// 移动端调试
// import Vconsole from 'vconsole';
// const vConsole = new Vconsole();

// 中汽数据，查看回放视频
let hls = require('videojs-contrib-hls')
Vue.use(hls)
Vue.use(VideoPlayer)

Vue.config.productionTip= false
Vue.use(Element)
Vue.use(VueDND)
Vue.use(htmlToPdf)

// 百度sem
router.afterEach( ( to, from, next ) => {
  setTimeout(()=>{
    var _hmt = _hmt || [];
    (function() {
      var hm = document.createElement("script");
      hm.src = "https://hm.baidu.com/hm.js?a445555c93e8613dcb50a96a1ecae58f";
      var s = document.getElementsByTagName("script")[0]; 
      s.parentNode.insertBefore(hm, s);
    })();
  },0);
} );
/* eslint-disable no-new */
const vm = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
export default vm



// WEBPACK FOOTER //
// ./src/main.js